<fadv-loader *ngIf="loading" [duration]="2200" [open]="true"></fadv-loader>
<fadv-grid gutter="large">
    <fadv-grid-row>
      <fadv-grid-col alignment="center" col="12">
        <fadv-box mb="x-large">
          <div id="package-selection-header">
            <fadv-typography type="heading-x-small" [weight]="500">Select a Package To Begin Screening</fadv-typography>
          </div>
        </fadv-box>
      </fadv-grid-col>
    </fadv-grid-row>
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <fadv-grid-row>
        <fadv-grid-col [col]="{ xxl: 3, xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }" *ngFor="let package of packages">
          <fadv-box [mb]="{ md: 'medium', sm: 'medium', xs: 'medium'}">
            <app-package-details [form]="form" [package]="package" (selectPackage)="selectPackage($event)"></app-package-details>
          </fadv-box>
        </fadv-grid-col>
      </fadv-grid-row>
      <div>
        <fadv-grid-row>
          <fadv-grid-col alignment="center" col="12">
            <fadv-box mb="x-large">
              <div id="additional-items-header">
                <fadv-typography type="heading-x-small" variant="neutral" [weight]="500">Additional Items</fadv-typography>
              </div>
            </fadv-box>
          </fadv-grid-col>
        </fadv-grid-row>
        <fadv-grid-row>
          <fadv-grid-col *ngFor="let product of products" [col]="{ xxl: 4, xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }">
            <fadv-box p="medium">
              <app-ala-carte-product [formGroup]="addOnForm" [hideDlProduct]="hideDlProduct" [product]="product" (emitter)="handleProductCheckbox($event, product.id)"></app-ala-carte-product>
            </fadv-box>
          </fadv-grid-col>
        </fadv-grid-row>
      </div>
      <fadv-box [mt]="{ xxl: 'x-large', xl: 'x-large', lg: 'x-large', md: 'medium', sm: 'small', xs: 'small' }">
        <fadv-grid-row>
          <fadv-grid-col col="12" alignment="center">
            <fadv-box [mb]="{ xxl: 'xx-large', xl: 'xx-large', lg: 'x-large', md: 'large', sm: 'medium', xs: 'medium' }">
            <fadv-typography type="label-medium" weight="400" variant="neutral" >Need a package you don't see? 
              <fadv-typography type="label-medium" strong="true" weight="500" variant="primary"><a (click)="contactUs()">Contact us for more information</a></fadv-typography> 
            </fadv-typography>
          </fadv-box>
          </fadv-grid-col>
        </fadv-grid-row>
        <fadv-grid-row>
          <fadv-grid-col [col]="{ xxl: 6, xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }" alignment="{{backButtonAlignment}}">
            <fadv-box [mb]="{ md: 'medium', sm: 'medium', xs: 'medium'}">
              <fadv-button class="package-form-button" (click)="onCancel()" name="partner-package-back-button">Back</fadv-button>
            </fadv-box>
          </fadv-grid-col>
          <fadv-grid-col [col]="{ xxl: 6, xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }" alignment="{{nextButtonAlignment}}">
            <fadv-button class="package-form-button" [disabled]="form.controls.packageID.value === '' && !hasAddOnProduct" 
            variant='primary' (click)="onSubmit()" name="partner-package-next-button">Next</fadv-button>
          </fadv-grid-col>
        </fadv-grid-row>
      </fadv-box>
    </form>
    <fadv-box mt="medium">
      <fadv-grid-row>
        <fadv-grid-col>
          <fadv-typography style="text-align: center" type="paragraph-small"><b>Turn around times may vary.</b></fadv-typography>
        </fadv-grid-col>
      </fadv-grid-row>
      <fadv-grid-row>
        <fadv-grid-col>
          <fadv-tooltip content="Out of pocket or pass-through fees may apply in addition to the cost of a First Advantage background check. These fees are passed through to the customer directly from state and county offices, such as county courts, motor vehicle departments, employment verifiers, and education institutions. First Advantage does not markup these additional data access fees.">
            <div>
              <fadv-typography style="text-align: center" type="paragraph-x-small">Sales tax and additional third-party fees may apply. <a href="https://fadv.com/smallbusiness/support/" target="_new">Learn more about pass&#8209;through/out of pocket fees.</a> </fadv-typography>
            </div>
          </fadv-tooltip>
        </fadv-grid-col>
      </fadv-grid-row>
  </fadv-box>
  </fadv-grid>
  <!-- <div class="embeddedServiceHelpButton">
    <div class="helpButton">
      <button class="helpButtonEnabled uiButton" (click)="onChat()" >
        <span class="embeddedServiceIcon" aria-hidden="true" data-icon="" style="display: inline-block;"></span>
        <span class="helpButtonLabel" id="helpButtonSpan" aria-live="polite" aria-atomic="true">
          <span class="assistiveText">Live chat:</span>
          <span class="message">Chat with an Expert</span>
        </span>
      </button>
    </div>
  </div> -->